module.exports = __webpack_public_path__ + "static/media/hall-emsd831.6fbb93bf.jpeg";